<div class="d-flex justify-content-between">
  <div>
    <span *scText="rendering?.fields?.BudgetBillSuggestion"></span>
    <wl-tooltip
      class="ps-1"
      [tooltip]="{
        description: rendering?.fields?.BudgetBillSuggestionTooltip?.value,
      }"
    ></wl-tooltip>
  </div>
  <div class="offer-overview-budget-bill__amount text-end">
    <strong>
      {{ budgetBillAmount | roundedCurrency }}
    </strong>
  </div>
</div>
@if (cashback) {
  <div class="d-flex justify-content-between">
    <div>
      <strong
        class="offer-overview-budget-bill__strong"
        *scText="rendering?.fields?.AppliedDiscount"
      ></strong>
      <wl-tooltip
        class="ps-1"
        [tooltip]="{
          description: rendering?.fields?.AppliedDiscountTooltip.value,
        }"
      ></wl-tooltip>
    </div>
    <div class="offer-overview-budget-bill__amount text-end">
      <strong>
        {{ cashback | roundedCurrency }}
      </strong>
    </div>
  </div>
}
